<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md [header]="'Direct'">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main
    *ngIf="directSubscription$ | async as sub"
    fxFlex
    class="subnav__exists"
    [ngClass.lt-md]="{ mobile: true }"
    fxLayout="column"
    fxLayoutGap="40px">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs class="!mb-0 block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>
    <div
      class="direct-subscription-container"
      [class.pending-cancellation]="sub.pending_cancellation_date"
      [class.trial]="sub.trial">
      <div
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start start"
        fxLayoutGap.lt-md="12px"
        fxLayoutAlign="space-between center"
        class="header-container">
        <h2 *ngIf="!sub.pending_cancellation_date && !sub.trial" class="nomargin">
          {{ sub.plan | directSubscriptionDescriptionFromKey }} features are active for your account
        </h2>

        <h2 *ngIf="sub.trial" class="nomargin">Activate Direct to start taking direct bookings</h2>

        <h2 *ngIf="sub.pending_cancellation_date" class="nomargin">Your Direct plan is scheduled to be deactivated</h2>
      </div>

      <div fxLayout="column" fxLayoutGap="12px">
        <!-- Paid state (Any plan)-->
        <ng-container *ngIf="!sub.pending_cancellation_date">
          <sbnb-direct-plan-grid-item *ngIf="(isOnProfessionalPlan$ | async) === true">
            Professional tier subscriptions include all Hospitable direct booking features and our integration with
            Google Vacation Rentals.
          </sbnb-direct-plan-grid-item>

          <sbnb-direct-plan-grid-item *ngIf="sub.plan === DirectPlan.Basic && (isOnProfessionalPlan$ | async) === true">
            <span
              *ngIf="
                eligibleSwitchPlans &&
                  eligibleSwitchPlans.length > 0 &&
                  eligibleSwitchPlans.includes(DirectPlan.Premium);
                else defaultMessage
              ">
              Hospitable collects a 1% host fee on bookings. Payment processing fees, guest vetting, and damage
              protection are not included.
            </span>
            <ng-template #defaultMessage>
              <span>
                Hospitable collects a 1% host fee on bookings. Stripe deducts payment processing fees from the payout.
              </span>
            </ng-template>
          </sbnb-direct-plan-grid-item>

          <sbnb-direct-plan-grid-item
            *ngIf="sub.plan === DirectPlan.Premium && (isOnProfessionalPlan$ | async) === true">
            Hospitable collects a 4% guest service fee and 3% host fee. Guest vetting, damage protection, payment
            processing fees, a fraud chargeback guarantee are included.
          </sbnb-direct-plan-grid-item>

          <sbnb-direct-plan-grid-item *ngIf="sub.plan === DirectPlan.Lite">
            Integrated payment processing is not available. All payments must be collected off platform.
          </sbnb-direct-plan-grid-item>
        </ng-container>

        <!-- Trial state (Any plan) -->
        <ng-container *ngIf="sub.trial">
          <sbnb-direct-plan-grid-item>
            An active subscription is required for published Direct sites and booking widgets.
          </sbnb-direct-plan-grid-item>

          <sbnb-direct-plan-grid-item>
            Get your Direct site and payout methods set up at your own pace.
          </sbnb-direct-plan-grid-item>

          <sbnb-direct-plan-grid-item>
            You won't be charged any additional fees until you publish your site or booking widget.
          </sbnb-direct-plan-grid-item>

          <sbnb-direct-plan-grid-item>
            Once you activate Direct, you will be charged monthly for each unique property published on any Direct site
            or booking widget.
          </sbnb-direct-plan-grid-item>

          <!-- <sbnb-direct-plan-grid-item *ngIf="sub.active_direct_properties > 0">
            If you activate Direct an additional fee of
            <strong>{{ sub.charge_amount }}</strong>
            for
            <strong>{{ sub.active_direct_properties }}</strong>
            properties will appear on your next {{ 'CORE.PRODUCT_NAME' | transloco }} invoice on
            <strong>{{ sub.next_charge_date | date }}</strong>
            .
          </sbnb-direct-plan-grid-item>

          <sbnb-direct-plan-grid-item *ngIf="sub.active_direct_properties === 0">
            Add properties to your Direct sites or booking widgets to see how much Direct will cost for you.
          </sbnb-direct-plan-grid-item> -->
        </ng-container>

        <!-- Pending cancellation -->
        <ng-container *ngIf="sub.pending_cancellation_date">
          <sbnb-direct-plan-grid-item [negative]="true">
            Your Direct sites and booking widgets will be unpublished on
            <strong>{{ sub.pending_cancellation_date | date }}</strong>
            .
          </sbnb-direct-plan-grid-item>
          <sbnb-direct-plan-grid-item [negative]="true">
            You can continue to use your Direct sites and accept bookings until that point.
          </sbnb-direct-plan-grid-item>
          <sbnb-direct-plan-grid-item [negative]="true">
            Your existing Direct bookings will not be impacted.
          </sbnb-direct-plan-grid-item>
          <sbnb-direct-plan-grid-item [negative]="true">
            You will not be be charged for Direct on your next invoice.
          </sbnb-direct-plan-grid-item>
        </ng-container>
      </div>
    </div>

    <div class="direct-subscription-actions-container">
      <!-- Activate from a trial -->
      <div *ngIf="sub.trial" fxLayout class="direct-subscription-action">
        <div fxFlex fxLayoutGap="6px" fxLayout="column">
          <h3>Activate Direct</h3>
          <span>I want to start taking bookings, and I accept the additional fees.</span>
        </div>

        <sbnb-button fxFlex="180px" [fullWidth]="true" (clicked)="activate()">Activate</sbnb-button>
      </div>

      <!-- Plan switching -->
      <ng-container *ngIf="!sub.pending_cancellation_date && eligibleSwitchPlans?.length > 0">
        <div
          *ngIf="eligibleSwitchPlans.includes(DirectPlan.Basic)"
          fxLayout
          fxLayoutGap="12px"
          class="direct-subscription-action">
          <div fxFlex fxLayoutGap="6px" fxLayout="column">
            <h3>Switch to {{ DirectPlan.Basic | directSubscriptionDescriptionFromKey }}</h3>
            <span>
              I don't need guest vetting, chargeback and damage protection. I will pay my own payment processing fees.
              Any bookings already made will not be affected.
              <a
                class="link"
                target="_blank"
                href="https://my.hospitable.com/support-documentation/article/5845339-all-about-direct-bookings">
                Learn more about {{ DirectPlan.Basic | directSubscriptionDescriptionFromKey }}
              </a>
            </span>
          </div>

          <sbnb-button fxFlex="180px" type="secondary" [fullWidth]="true" (click)="switchPlan(DirectPlan.Basic)">
            Switch
          </sbnb-button>
        </div>

        <div
          *ngIf="eligibleSwitchPlans.includes(DirectPlan.Premium)"
          fxLayout
          fxLayoutGap="12px"
          class="direct-subscription-action">
          <div fxFlex fxLayoutGap="6px" fxLayout="column">
            <h3>Switch to {{ DirectPlan.Premium | directSubscriptionDescriptionFromKey }}</h3>
            <span>
              I want integrated guest vetting, chargeback and damage protection. Premium is only available for US, UK
              and Australian properties. Any bookings already made will not be affected.
              <a
                class="link"
                target="_blank"
                href="https://my.hospitable.com/support-documentation/article/5845339-all-about-direct-bookings">
                Learn more about {{ DirectPlan.Premium | directSubscriptionDescriptionFromKey }}
              </a>
            </span>
          </div>

          <sbnb-button fxFlex="180px" type="secondary" [fullWidth]="true" (click)="switchPlan(DirectPlan.Premium)">
            Switch
          </sbnb-button>
        </div>

        <div
          *ngIf="eligibleSwitchPlans.includes(DirectPlan.Lite)"
          fxLayout
          fxLayoutGap="12px"
          class="direct-subscription-action">
          <div fxFlex fxLayoutGap="6px" fxLayout="column">
            <h3>Switch to {{ DirectPlan.Lite | directSubscriptionDescriptionFromKey }}</h3>
            <span>
              For hosts who are unable to get a Stripe account. Integrated payment processing is not available. All
              payments must be collected off platform. Any bookings already made will not be affected.
              <a
                class="link"
                target="_blank"
                href="https://my.hospitable.com/support-documentation/article/5845339-all-about-direct-bookings">
                Learn more about {{ DirectPlan.Lite | directSubscriptionDescriptionFromKey }}
              </a>
            </span>
          </div>

          <sbnb-button fxFlex="180px" type="secondary" [fullWidth]="true" (click)="switchPlan(DirectPlan.Lite)">
            Switch
          </sbnb-button>
        </div>
      </ng-container>

      <ng-container *ngIf="isOnProfessionalPlan$ | async as isOnProfessionalPlan">
        <div
          *ngIf="!sub.trial && !sub.pending_cancellation_date && !isOnProfessionalPlan"
          fxLayout
          class="direct-subscription-action">
          <div fxFlex fxLayoutGap="6px" fxLayout="column">
            <h3>Deactivate Direct features</h3>
            <span>Your sites and widgets will be unpublished immediately. Existing bookings are not impacted.</span>
          </div>

          <sbnb-button fxFlex="180px" type="secondary" [fullWidth]="true" (clicked)="cancelDirect()">
            Deactivate
          </sbnb-button>
        </div>
      </ng-container>

      <div *ngIf="sub.pending_cancellation_date" fxLayout class="direct-subscription-action">
        <div fxFlex fxLayoutGap="6px" fxLayout="column">
          <h3>Reactivate your Direct plan</h3>
          <span>I want to continue using Direct, and I accept the additional fees.</span>
        </div>

        <sbnb-button
          fxFlex="180px"
          type="secondary"
          [loading]="isCancellingCancellation"
          [fullWidth]="true"
          (clicked)="keepDirect()">
          Keep Direct
        </sbnb-button>
      </div>
    </div>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
